/**
 * SortableTaxonomyField - Wrapper for TaxonomyFieldEditor with drag-and-drop support
 */

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { TaxonomyFieldEditor, type TaxonomyFieldEditorProps } from './TaxonomyFieldEditor';

export function SortableTaxonomyField(props: TaxonomyFieldEditorProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.field.fieldId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <TaxonomyFieldEditor
        {...props}
        dragHandleProps={{ ...attributes, ...listeners }}
      />
    </div>
  );
}
